import React from 'react';
import {
  Typography,
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { getNavigateToLoginOptions } from '../../../utils/authSessionExpired';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CloseIcon from '@mui/icons-material/Close';
import {
  StyledAuthDialog,
  AuthDialogTitle,
  AuthModalCloseButton,
  AuthDialogContent,
  AuthDialogActions,
  AuthSecondaryButton,
  AuthPrimaryButton,
} from './AuthModal.styled';

const AuthModal = ({
  open,
  onClose,
  onLogin,
  onCreateAccount,
  title = 'Account Required',
  message = 'This feature requires an account. Would you like to create an account or log in?',
  showCancel = true,
  cancelText = 'Cancel',
  loginText = 'Log In',
  createAccountText = 'Create Account',
  postAuthRedirectPath,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const intendedPath =
    postAuthRedirectPath || `${location.pathname}${location.search || ''}`;

  const handleLogin = () => {
    if (onLogin) {
      onLogin();
    } else {
      onClose();
      navigate('/login', getNavigateToLoginOptions(intendedPath));
    }
  };

  const handleCreateAccount = () => {
    if (onCreateAccount) {
      onCreateAccount();
    } else {
      onClose();
      navigate('/sign-up', {
        replace: true,
        state: { from: intendedPath },
      });
    }
  };

  return (
    <StyledAuthDialog
      open={open}
      onClose={onClose}
      aria-labelledby="auth-required-dialog"
    >
      <AuthDialogTitle id="auth-required-dialog">
        <span className="auth-modal-icon-wrap">
          <AccountCircleIcon className="auth-modal-icon" />
        </span>
        {title}
        <AuthModalCloseButton
          aria-label="close"
          onClick={onClose}
        >
          <CloseIcon />
        </AuthModalCloseButton>
      </AuthDialogTitle>
      <AuthDialogContent>
        <Typography>{message}</Typography>
      </AuthDialogContent>
      <AuthDialogActions>
        {showCancel && (
          <AuthSecondaryButton onClick={onClose} variant="outlined">
            {cancelText}
          </AuthSecondaryButton>
        )}
        <AuthSecondaryButton onClick={handleLogin} variant="outlined">
          {loginText}
        </AuthSecondaryButton>
        <AuthPrimaryButton
          onClick={handleCreateAccount}
          variant="contained"
        >
          {createAccountText}
        </AuthPrimaryButton>
      </AuthDialogActions>
    </StyledAuthDialog>
  );
};

export default AuthModal;
